/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net Command API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  MessageResponse,
  SchemaValidationErrorResponse,
  StandardError,
  SupporterContribution,
  SupporterContributionInput,
  SupporterContributionMonthlyStats,
  SupporterContributionStats,
  SupporterContributions,
  SupporterContributionsParams,
  SupporterContributionsPerMonthParams,
  SupporterContributionsStatsParams,
  ValidationError
} from '../../models';

import { axiosClient } from '../../../axiosAdminClient.ts';
import type { ErrorType } from '../../../axiosAdminClient.ts';




/**
 * @summary Create Supporter Contribution
 */
export const createSupporterContribution = (
    supporterContributionInput: MaybeRefOrGetter<SupporterContributionInput>,
 signal?: AbortSignal
) => {
      supporterContributionInput = toValue(supporterContributionInput);

      return axiosClient<SupporterContribution>(
      {url: `/supporter-contributions`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: supporterContributionInput, signal
    },
      );
    }




export const getCreateSupporterContributionMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSupporterContribution>>, TError,CreateSupporterContributionMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createSupporterContribution>>, TError,CreateSupporterContributionMutationVariables, TContext> => {

const mutationKey = ['createSupporterContribution'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createSupporterContribution>>, CreateSupporterContributionMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createSupporterContribution(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateSupporterContributionMutationResult = NonNullable<Awaited<ReturnType<typeof createSupporterContribution>>>
    export type CreateSupporterContributionMutationBody = SupporterContributionInput
    export type CreateSupporterContributionMutationError = ErrorType<ValidationError | StandardError>
    export type CreateSupporterContributionMutationVariables = {data: SupporterContributionInput}

    /**
 * @summary Create Supporter Contribution
 */
export const useCreateSupporterContribution = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSupporterContribution>>, TError,CreateSupporterContributionMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createSupporterContribution>>,
        TError,
        CreateSupporterContributionMutationVariables,
        TContext
      > => {
      return useMutation(getCreateSupporterContributionMutationOptions(options), queryClient);
    }
    /**
 * @summary Supporter Contributions list
 */
export const supporterContributions = (
    params?: MaybeRefOrGetter<SupporterContributionsParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<SupporterContributions>(
      {url: `/supporter-contributions`, method: 'GET',
        params, signal
    },
      );
    }




export const getSupporterContributionsQueryKey = (params?: MaybeRefOrGetter<SupporterContributionsParams>,) => {
    return [
    'supporter-contributions', ...(params ? [params] : [])
    ] as const;
    }


export const getSupporterContributionsQueryOptions = <TData = Awaited<ReturnType<typeof supporterContributions>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(params?: MaybeRefOrGetter<SupporterContributionsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supporterContributions>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getSupporterContributionsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof supporterContributions>>> = ({ signal }) => supporterContributions(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof supporterContributions>>, TError, TData>
}

export type SupporterContributionsQueryResult = NonNullable<Awaited<ReturnType<typeof supporterContributions>>>
export type SupporterContributionsQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Supporter Contributions list
 */

export function useSupporterContributions<TData = Awaited<ReturnType<typeof supporterContributions>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 params?: MaybeRefOrGetter<SupporterContributionsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supporterContributions>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSupporterContributionsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Supporter Contributions Per Month
 */
export const supporterContributionsPerMonth = (
    params?: MaybeRefOrGetter<SupporterContributionsPerMonthParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<SupporterContributionMonthlyStats>(
      {url: `/supporter-contributions/per-month`, method: 'GET',
        params, signal
    },
      );
    }




export const getSupporterContributionsPerMonthQueryKey = (params?: MaybeRefOrGetter<SupporterContributionsPerMonthParams>,) => {
    return [
    'supporter-contributions','per-month', ...(params ? [params] : [])
    ] as const;
    }


export const getSupporterContributionsPerMonthQueryOptions = <TData = Awaited<ReturnType<typeof supporterContributionsPerMonth>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(params?: MaybeRefOrGetter<SupporterContributionsPerMonthParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supporterContributionsPerMonth>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getSupporterContributionsPerMonthQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof supporterContributionsPerMonth>>> = ({ signal }) => supporterContributionsPerMonth(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof supporterContributionsPerMonth>>, TError, TData>
}

export type SupporterContributionsPerMonthQueryResult = NonNullable<Awaited<ReturnType<typeof supporterContributionsPerMonth>>>
export type SupporterContributionsPerMonthQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Supporter Contributions Per Month
 */

export function useSupporterContributionsPerMonth<TData = Awaited<ReturnType<typeof supporterContributionsPerMonth>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 params?: MaybeRefOrGetter<SupporterContributionsPerMonthParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supporterContributionsPerMonth>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSupporterContributionsPerMonthQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Supporter Contributions Stats
 */
export const supporterContributionsStats = (
    params?: MaybeRefOrGetter<SupporterContributionsStatsParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<SupporterContributionStats>(
      {url: `/supporter-contributions/stats`, method: 'GET',
        params, signal
    },
      );
    }




export const getSupporterContributionsStatsQueryKey = (params?: MaybeRefOrGetter<SupporterContributionsStatsParams>,) => {
    return [
    'supporter-contributions','stats', ...(params ? [params] : [])
    ] as const;
    }


export const getSupporterContributionsStatsQueryOptions = <TData = Awaited<ReturnType<typeof supporterContributionsStats>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(params?: MaybeRefOrGetter<SupporterContributionsStatsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supporterContributionsStats>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getSupporterContributionsStatsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof supporterContributionsStats>>> = ({ signal }) => supporterContributionsStats(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof supporterContributionsStats>>, TError, TData>
}

export type SupporterContributionsStatsQueryResult = NonNullable<Awaited<ReturnType<typeof supporterContributionsStats>>>
export type SupporterContributionsStatsQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Supporter Contributions Stats
 */

export function useSupporterContributionsStats<TData = Awaited<ReturnType<typeof supporterContributionsStats>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 params?: MaybeRefOrGetter<SupporterContributionsStatsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supporterContributionsStats>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSupporterContributionsStatsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Sync Supporter Contributions from Patreon
 */
export const syncSupporterContributionsFromPatreon = (

 signal?: AbortSignal
) => {


      return axiosClient<MessageResponse>(
      {url: `/supporter-contributions/sync-patreon`, method: 'POST', signal
    },
      );
    }




export const getSyncSupporterContributionsFromPatreonMutationOptions = <TError = ErrorType<StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof syncSupporterContributionsFromPatreon>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof syncSupporterContributionsFromPatreon>>, TError,void, TContext> => {

const mutationKey = ['syncSupporterContributionsFromPatreon'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof syncSupporterContributionsFromPatreon>>, void> = () => {


          return  syncSupporterContributionsFromPatreon()
        }






  return  { mutationFn, ...mutationOptions }}

    export type SyncSupporterContributionsFromPatreonMutationResult = NonNullable<Awaited<ReturnType<typeof syncSupporterContributionsFromPatreon>>>

    export type SyncSupporterContributionsFromPatreonMutationError = ErrorType<StandardError>


    /**
 * @summary Sync Supporter Contributions from Patreon
 */
export const useSyncSupporterContributionsFromPatreon = <TError = ErrorType<StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof syncSupporterContributionsFromPatreon>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof syncSupporterContributionsFromPatreon>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getSyncSupporterContributionsFromPatreonMutationOptions(options), queryClient);
    }
    /**
 * @summary Destroy Supporter Contribution
 */
export const destroySupporterContribution = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<SupporterContribution>(
      {url: `/supporter-contributions/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDestroySupporterContributionMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroySupporterContribution>>, TError,DestroySupporterContributionMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof destroySupporterContribution>>, TError,DestroySupporterContributionMutationVariables, TContext> => {

const mutationKey = ['destroySupporterContribution'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof destroySupporterContribution>>, DestroySupporterContributionMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  destroySupporterContribution(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DestroySupporterContributionMutationResult = NonNullable<Awaited<ReturnType<typeof destroySupporterContribution>>>

    export type DestroySupporterContributionMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type DestroySupporterContributionMutationVariables = {id: string}

    /**
 * @summary Destroy Supporter Contribution
 */
export const useDestroySupporterContribution = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroySupporterContribution>>, TError,DestroySupporterContributionMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof destroySupporterContribution>>,
        TError,
        DestroySupporterContributionMutationVariables,
        TContext
      > => {
      return useMutation(getDestroySupporterContributionMutationOptions(options), queryClient);
    }
    /**
 * @summary Supporter Contribution Detail
 */
export const supporterContribution = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<SupporterContribution>(
      {url: `/supporter-contributions/${id}`, method: 'GET', signal
    },
      );
    }




export const getSupporterContributionQueryKey = (id: MaybeRefOrGetter<string>,) => {
    return [
    'supporter-contributions',id
    ] as const;
    }


export const getSupporterContributionQueryOptions = <TData = Awaited<ReturnType<typeof supporterContribution>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supporterContribution>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getSupporterContributionQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof supporterContribution>>> = ({ signal }) => supporterContribution(id, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof supporterContribution>>, TError, TData>
}

export type SupporterContributionQueryResult = NonNullable<Awaited<ReturnType<typeof supporterContribution>>>
export type SupporterContributionQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Supporter Contribution Detail
 */

export function useSupporterContribution<TData = Awaited<ReturnType<typeof supporterContribution>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supporterContribution>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSupporterContributionQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Update Supporter Contribution
 */
export const updateSupporterContribution = (
    id: MaybeRefOrGetter<string>,
    supporterContributionInput: MaybeRefOrGetter<SupporterContributionInput>,
 signal?: AbortSignal
) => {
      id = toValue(id);
supporterContributionInput = toValue(supporterContributionInput);

      return axiosClient<SupporterContribution>(
      {url: `/supporter-contributions/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: supporterContributionInput, signal
    },
      );
    }




export const getUpdateSupporterContributionMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSupporterContribution>>, TError,UpdateSupporterContributionMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateSupporterContribution>>, TError,UpdateSupporterContributionMutationVariables, TContext> => {

const mutationKey = ['updateSupporterContribution'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateSupporterContribution>>, UpdateSupporterContributionMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  updateSupporterContribution(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateSupporterContributionMutationResult = NonNullable<Awaited<ReturnType<typeof updateSupporterContribution>>>
    export type UpdateSupporterContributionMutationBody = SupporterContributionInput
    export type UpdateSupporterContributionMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type UpdateSupporterContributionMutationVariables = {id: string;data: SupporterContributionInput}

    /**
 * @summary Update Supporter Contribution
 */
export const useUpdateSupporterContribution = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSupporterContribution>>, TError,UpdateSupporterContributionMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateSupporterContribution>>,
        TError,
        UpdateSupporterContributionMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateSupporterContributionMutationOptions(options), queryClient);
    }
